import { toast } from "react-toastify";
import { _AdquisitionItemCDP, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { useEffect, useState } from "react";
import { Modal } from "../../../../theme/Component/Modal";
import { CDPsEditor } from "../../../../contabilidad/budgetRPFactory/CDPsEditor";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { Singleton } from "../../../../../core/services/Singleton";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { ErrorList } from "../../../../theme/Component/ErrorList";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { BasicButton } from "../../../../theme/Component/BasicButton";

interface Props {
    adquisitionItem: any;
}

export const AdquisitionItemCDP = ({ adquisitionItem }: Props) => {

    const { lista, setLista, instance, bean, setBean, deleteItem } = useDataBean(_AdquisitionItemCDP);
    const single = Singleton.getInstance();

    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [documents, setDocuments] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalView, setModalView] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar Item", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        if (adquisitionItem.IDAdquisitionItem) {
            getLista();
        }
    }, [adquisitionItem])

    const getLista = () => {
        instance.getCDPBudgetByDocument(year, adquisitionItem.IDAdquisitionItem).then(
            (resp) => {
                setLista(resp);
                console.log(resp);
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    const createCDP = () => {
        setBean({
            IDAdquisitionItem: adquisitionItem.IDAdquisitionItem,
        });
        setModal({ ...modal, "view": true, "name": "Agregar CDP" });
    }

    const update = () => {
        instance.setAdquisitionItemToCDP(adquisitionItem.IDAdquisitionItem, bean.IDDocument, bean.DocumentDate, _single.getAccountID(), true).then(
            (resp) => {
                setModal({ ...modal, "view": false });
                setDocuments(resp.DocumentURL);
                setMsgList(resp.MsgList);
                setModalView({ ...modalView, "view": true, "name": "Documento Generado" })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObject = () => {
        deleteItem(bean.IDAdquisitionContractCDP).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDDocument', visible: false, mask: MASK_NUMBER },
        { title: 'Fecha', property: 'DocumentDate', visible: true, mask: MASK_DATE },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Rubro', property: 'BudgetIDName', visible: true },
        { title: 'Recurso', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente', property: 'BudgetSourceName', visible: true },
        { title: 'Valor', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Estado del Documento', property: 'DocumentStateName', visible: false },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: () => { createCDP() } }
    ]

    useEffect(() => {
        if (modalView.view) {
            getLista();
        }
    }, [modalView])

    const listaBotones = () => {
        const botones = [
            // { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <div className="row">
            <div className="col-md-6">
                <YearSelector value={year} onChange={(e) => { setYear(e) }} />
            </div>
            <div className="col-md-6 mt-4">
                <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={"Buscar"} />
            </div>
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />
            </div>
            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={update}>
                    <div className="row">
                        <div className="col-md-12">
                            <CDPsEditor onChange={(e) => { setBean({ ...bean, "IDDocument": e.IDDocument, "DocumentDate": e.Since, "DocumentState": e.DocumentState, "Consecutive": e.Consecutive, "Mnemonic": e.Mnemonic, }) }} />
                        </div>
                    </div>
                </Modal>
            </div>
            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteObject}>
                    <p>Esta seguro que desea eliminar el item {`${bean.Mnemonic} - ${bean.Consecutive}`}</p>
                </ModalConfirm>
            </div>
            <div className="col-md-12">
                <Modal modal={modalView} updateModal={setModalView}>
                    {msgList.length > 0 &&
                        <ErrorList lista={msgList} />
                    }
                    {msgList.length === 0 && documents.length > 0 &&
                        <DocumentViewer key={documents} list={documents} />
                    }
                </Modal>
            </div>
        </div>
    )

}